/* src/app/location-users/add-location-users/import-invalid-entries-modal/import-invalid-entries-modal.component.scss */
.modal-header {
  border-bottom: none;
  padding: 22px 16px 16px 60px;
}
.modal-header h4 {
  font-size: 32px;
}
.modal-body {
  padding: 0 34.5px 0 60px;
  border-bottom: none;
}
.modal-footer {
  padding: 0 0 24px 0;
  border-top: none;
}
.instructions {
  padding-right: 60px;
}
.instructions p {
  margin-bottom: 8px;
}
table,
th,
td {
  border: 1px solid #6e6e6e;
  border-collapse: collapse;
}
.table-container {
  max-height: 15rem;
  overflow-y: auto;
}
.error-table {
  table-layout: fixed;
  width: 100%;
  height: fit-content;
}
.error-table th {
  font-size: 10px;
  font-weight: normal;
  text-align: center;
  height: 24px;
  color: #6e6e6e;
}
.error-table td {
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
}
.error-table td.error {
  background-color: #C91A13;
  color: white;
}
.error-table td.unchecked-field {
  color: #BEBEBE;
}
.error-table td:nth-of-type(1),
.error-table th:nth-of-type(1) {
  width: 32px;
}
.error-table td:nth-of-type(2),
.error-table th:nth-of-type(2) {
  width: 72px;
}
.error-table td:nth-of-type(3),
.error-table th:nth-of-type(3) {
  width: 104px;
}
.error-table td:nth-of-type(4),
.error-table th:nth-of-type(4) {
  width: 104px;
}
.error-table td:nth-of-type(5),
.error-table th:nth-of-type(5) {
  width: 198px;
}
.error-table td:nth-of-type(6),
.error-table th:nth-of-type(6) {
  width: 198px;
}
.error-table td:nth-of-type(7),
.error-table th:nth-of-type(7) {
  width: 114px;
}
.error-table td:nth-of-type(5),
.error-table td:nth-of-type(6) {
  padding: 0 8px;
}
.btn {
  margin-top: 24px;
  height: 36px;
  border-radius: 100px;
  border: 0;
  padding-right: 28px;
  padding-left: 28px;
}
.btn-green {
  color: white;
  background-color: #00857D;
}
/*# sourceMappingURL=import-invalid-entries-modal.component.css.map */
